import { getInitialValuesForAdd as getInitialValues, getValidationSchema, getDataToSend } from '../DataTable/formUtil'
import { Tab, TabList, TabPanel as TabBody, Tabs } from 'react-tabs'
import 'react-tabs/style/react-tabs.css';
import { MdLanguage } from 'react-icons/md'
import ViewPage from '../../../../Layout/Dashboard/ViewPage';
import { useTranslation } from 'react-i18next';

import Form from './AddForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useAddProjectImage } from '../../../../api/Project';
import { useEffect } from 'react';

const AddProjectPage = () => {


  const navigate = useNavigate()
  const { mutate, isLoading:IsloadingButton,isSuccess } = useAddProjectImage()
  const {id} = useParams()
  const handleSubmit = (values: any) => {
    const transformedValues = { ...values , project_id:id }; // Create a new object
  
    mutate(transformedValues);
  };
  
useEffect(() => {
  if(isSuccess){
    navigate(-1)

  }
}, [isSuccess,navigate])

  const { t } = useTranslation();



  const ViewProps = { getInitialValues, getValidationSchema, getDataToSend, handleSubmit,IsloadingButton };


  return (
    <div className='ViewPage'>

      <ViewPage {...ViewProps}>
        <Tabs>
          <TabList>
            <Tab><div className='SignleDriverContainer'><span className='SignleDriverInfoIcon'><MdLanguage size={20} /></span> <h6 className='SingleDriverInfo'>{t("BasicInfo")}</h6></div></Tab>



          </TabList>
          <TabBody >
            <div className=" mt-4"><Form /></div>
          </TabBody>

        </Tabs>
      </ViewPage>



    </div>
  )

}

export default AddProjectPage